
export const resolveCorrespondingStatName= (multName) => {
  /*
    Mock company data object structure for reference with mult field names and corresponding value field name
    {
      id: 430,
      ticker: 'TSM',
      name: 'Taiwan Semiconductor Manufacturing',
      marketCapitalization: 1775.85913856,
      sharePrice: 342.4,
      shares: 5.186504493457944,
      totalDebt: 993.153974272,
      totalCash: 3068.593963008,
      ttmRevenue: 3809.053851,
      ttmNetIncome: 1717.882637,
      ttmEbitda: 2023.529576,
      currentYearRevEst: 4980.0805898,
      nextYearRevEst: 5987.45688863,
      currentYearEpsEst: 14.31,
      nextYearEpsEst: 18,
      timestamp: 2026-01-19T20:21:03.083Z,
      EV: -299.58085017600024,
      ttmRevenueMultiple: -0.07864967571864351,
      currentYearRevenueMultiple: -0.060155823741003235,
      nextYearRevenueMultiple: -0.0500347402492192,
      ttmEbitdaMultiple: -0.14804866394302718,
      ttmPeMultiple: 1.0337488139825701,
      currentYearPeMultiple: 23.927323549965056,
      nextYearPeMultiple: 19.022222222222222,
      forwardRevenueGrowth: 20.228112390254637,
      ttmEbitdaMargin: 53.124204990400905,
      forwardEarningsGrowth: 25.786163522012572,
      ruleOf40: 73.35231738065553,
      fiftyTwoWeekHigh: 247.06,
      fiftyTwoWeekLow: 87.36,
      priorYearEbitda: 0.007177,
      priorYearEps: -0.35611589977081637,
      priorYearNetIncome: -0.010847,
      priorYearRevenue: 0.361075
    }
  */

  const mapping = {
    'ttmRevenueMultiple': 'ttmRevenue',
    'currentYearRevenueMultiple': 'currentYearRevEst',
    'nextYearRevenueMultiple': 'nextYearRevEst',
    'ttmEbitdaMultiple': 'ttmEbitda',
    'ttmPeMultiple': 'ttmEps',
    'currentYearPeMultiple': 'currentYearEpsEst',
    'nextYearPeMultiple': 'nextYearEpsEst'
  };
  return mapping[multName];
};

